var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"ma-2 white--text",attrs:{"color":"green"},on:{"click":_vm.openUploadModal}},[_vm._v(" Image "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-cloud-upload ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }